// ----------------------------------------------------------------------
// Amik Design System — brand tokens
// Source: claude.ai/design "Amik Design System" (tokens/colors.css,
// typography.css, spacing.css). These are applied ONLY on the Amik domain
// (gated via domainConfig.isAmik); other white-label tenants are untouched.
// ----------------------------------------------------------------------

export const AMIK = {
  // Core brand trio
  blue: "#1488D6",
  teal: "#1FA98C",
  green: "#4CB749",

  // Signature gradient (118° sweep) — energy → electric
  gradient: "linear-gradient(118deg, #1488D6 0%, #1FA98C 52%, #4CB749 100%)",
  gradientSoft:
    "linear-gradient(118deg, rgba(20,136,214,.10), rgba(76,183,73,.10))",

  // Ink / text hierarchy
  ink: "#0F1A2B", // headings & primary text
  ink2: "#3C4D5E", // body copy
  muted: "#6E7D8B", // captions, meta, labels
  inkDeep: "#0B1422", // deepest surface (footers, covers)

  // Surfaces & lines
  white: "#FFFFFF",
  paper: "#F6F8FA",
  line: "#E6EAEE", // hairline borders
  line2: "#D6DCE2", // stronger borders

  // Radii
  radiusSm: 12,
  radius: 16,
  radiusLg: 24,

  // Type
  fontDisplay: "'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif",
  fontBody:
    "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  trackingHead: "-0.02em",
  trackingTight: "-0.03em",
  trackingEyebrow: "0.14em",

  // Elevation — low-contrast, blue-tinted lifts (never heavy black shadows)
  shadowBtn: "0 8px 22px rgba(20,120,170,.30)",
  shadowCard: "0 22px 40px -22px rgba(15,26,43,.30)",
  shadowPop: "0 26px 54px -22px rgba(15,26,43,.40)",
};

// Brand primary scale derived from the signature blue (#1488D6).
export const AMIK_PRIMARY = {
  lighter: "#E3F1FB",
  light: "#5BB0E6",
  main: "#1488D6",
  dark: "#0F6FB0",
  darker: "#0B5689",
  contrastText: "#fff",
};
